"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { logClientError } from "@/lib/client-error";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logClientError(error, "React render error");
  }, [error]);

  return (
    <div className="min-h-screen bg-muted/30 p-8">
      <h2 className="text-xl font-semibold text-destructive mb-4">Что-то пошло не так</h2>
      {error.digest && (
        <p className="text-sm text-muted-foreground mb-2">
          <span className="font-medium">Digest:</span> {error.digest}
        </p>
      )}
      {error.message && (
        <pre className="bg-black/10 rounded p-4 text-sm whitespace-pre-wrap break-all mb-4">
          {error.message}
        </pre>
      )}
      {error.stack && (
        <pre className="bg-black/10 rounded p-4 text-xs whitespace-pre-wrap break-all mb-6 text-muted-foreground">
          {error.stack}
        </pre>
      )}
      <Button onClick={reset}>Попробовать снова</Button>
    </div>
  );
}
